import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
import customContainerHeader from '@/components/custom-container-header';
import fastSearch from '@/components/fast-search';
import request from '@/api/request.js';
import util from '@/libs/util.js';
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable';
import { Add, DeleteTemplate } from '@/api/SysReportTpl';
var mesTable = MesTable('SysReportTpl/List');
export default {
  name: 'SysReportTpl',
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  })],
  components: {
    customContainerHeader: customContainerHeader,
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      loading: false,
      mainTable: [],
      totalPage: 0,
      selectRow: null,
      // 选中的行
      uploadUrl: this.$store.getters.getVUE_APP_PRINT_TPL + 'File/UploadPrintTPLFile',
      // 打印模板
      formData: {
        Page: 1,
        Limit: 15
      },
      validRules: {
        BillType: [{
          required: true,
          message: this.$t('单据类型必填'),
          trigger: 'blur'
        }],
        PaperType: [{
          required: true,
          message: this.$t('页面纸张类型必填'),
          trigger: 'blur'
        }],
        PathName: [{
          required: false,
          message: this.$t('报表路径及名称必填'),
          trigger: 'blur'
        }],
        Description: [{
          required: false,
          message: this.$t('说明必填'),
          trigger: 'blur'
        }],
        CreatedTime: [{
          required: false,
          message: this.$t('创建时间必填'),
          trigger: 'blur'
        }],
        CreatedBy: [{
          required: false,
          message: this.$t('创建人必填'),
          trigger: 'blur'
        }],
        UpdatedTime: [{
          required: false,
          message: this.$t('更新时间必填'),
          trigger: 'blur'
        }],
        UpdatedBy: [{
          required: false,
          message: this.$t('最后更新人必填'),
          trigger: 'blur'
        }],
        Deleted: [{
          required: false,
          message: this.$t('删除标记必填'),
          trigger: 'blur'
        }]
      },
      editVisible: false,
      editForm: {},
      editTitle: '',
      UploadParamVal: {
        ID: 0,
        BillType: '',
        PaperType: ''
      },
      userInfo: JSON.parse(util.cookies.get('userInfo'))
    };
  },
  created: function created() {
    this.getLoadData();
    console.log('editForm', this.editForm);
  },
  methods: {
    beforeClose: function beforeClose() {
      this.$refs.editForm.clearValidate();
      this.editVisible = false;
    },
    getLoadData: function getLoadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.selectRow = null;
                _this.loading = true;
                _context.next = 4;
                return mesTable.LoadData(_this.formData);

              case 4:
                res = _context.sent;
                _this.loading = false;

                if (res.code === 0) {
                  _this.mainTable = res.data;
                  _this.totalPage = res.TotalCount;
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    add: function add() {
      var _this2 = this;

      this.editTitle = this.$t('publics.btn.add');
      this.editForm = {}; // this.editForm = this.$options.data().editForm

      this.editVisible = true;
      this.$nextTick(function () {
        _this2.$refs.editForm.clearValidate();
      });
    },
    edit: function edit(row) {
      console.log('row', row);
      this.editTitle = this.$t('publics.btn.edit');
      this.editForm = row;
      this.editVisible = true;
    },
    // 搜索
    search: function search() {
      this.formData.Page = 1;
      this.getLoadData();
    },
    fastSearch: function fastSearch(searchData) {
      this.formData = searchData;
      this.getLoadData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.Limit = val;
      this.getLoadData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.Page = val;
      this.getLoadData();
    },
    // 删除
    remove: function remove(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$confirm(_this3.$t('publics.tips.makeSureDelete'), _this3.$t('publics.tips.tips'), {
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return DeleteTemplate(row.Id);

                        case 2:
                          res = _context2.sent;

                          if (res.code === 0) {
                            _this3.getLoadData();

                            _this3.$notify({
                              title: _this3.$t('publics.tips.success'),
                              message: _this3.$t('publics.tips.deleteSuccess'),
                              type: 'success',
                              duration: 2000
                            });
                          }

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    success: function success(response) {
      if (response.code === 0) {
        this.editVisible = false;
        this.getLoadData();
        this.$notify({
          title: this.$t('publics.tips.success'),
          message: this.$t('publics.tips.submitSuccess'),
          type: 'success',
          duration: 2000
        });
      } else {
        this.$notify.error({
          title: this.$t('publics.tips.fail'),
          message: this.$t('publics.tips.saveFail')
        });
      }
    },
    //  保存
    save: function save() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.$refs.editForm.validate( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                    var that, res;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (valid) {
                              _context4.next = 2;
                              break;
                            }

                            return _context4.abrupt("return", false);

                          case 2:
                            that = _this4;

                            if (!(_this4.editTitle === _this4.$t('publics.btn.add'))) {
                              _context4.next = 10;
                              break;
                            }

                            _context4.next = 6;
                            return Add(_this4.editForm);

                          case 6:
                            res = _context4.sent;
                            // console.log('res',res);
                            that.success(res); // if(res.code === 0){
                            //   this.$message.success('新增成功')
                            //   return
                            // }

                            _context4.next = 12;
                            break;

                          case 10:
                            _this4.editForm.UpdatedBy = _this4.userInfo.USER_NAME;
                            request.post('SysReportTpl/Update', _this4.editForm).then(function (response) {
                              // console.log('response', response)
                              if (response.code === 0) {
                                _this4.$message.success('修改成功');

                                _this4.editVisible = false;

                                _this4.getLoadData();
                              } // that.success(response)

                            });

                          case 12:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    beforeclickUpload: function beforeclickUpload() {
      if (this.selectRow == null) {
        this.$message.error(this.$t('请先选中一行。'));
        return false;
      }
    },
    // 上传文件前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      if (this.selectRow == null) {
        this.$message.error(this.$t('请先选中一行。'));
        return false;
      }

      this.UploadParamVal.ID = this.selectRow.Id;
      this.UploadParamVal.BillType = this.selectRow.BillType;
      this.UploadParamVal.PaperType = this.selectRow.PaperType; // debugger

      var isPrintFile = file.name.endsWith('.repx');
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!isPrintFile) {
        this.$message.error(this.$t('SOPRoutes._188'));
        return false;
      }

      if (!isLt2M) {
        this.$message.error(this.$t('SOPRoutes._189'));
        return false;
      }

      this.NaturaLloading = this.$loading({
        lock: true,
        // 同v-loading的修饰符
        text: this.$t('正在上传中...'),
        // 加载文案
        backgroundColor: 'rgba(55,55,55,0.4)',
        // 背景色
        spinner: 'el-icon-loading' // 加载图标

      });
      return isPrintFile && isLt2M;
    },
    // 上传成功后
    handleAvatarSuccess: function handleAvatarSuccess(response) {
      console.log('上传', response);

      if (response.code !== 0) {
        this.$message({
          message: response.msg,
          type: 'error'
        });
      } else {
        // debugger
        var that = this;
        var paramVal = {
          Id: that.UploadParamVal.ID,
          PathName: response.data.src
        };
        request.post('SysReportTpl/UpdateTPLFile', paramVal).then(function (response) {
          that.success(response);
        }); // this.$message({
        //   type: 'success',
        //   message: this.$t('se.picsucc')
        // })
      }

      this.NaturaLloading.close();
    },
    handleClose: function handleClose() {
      this.$refs.uploadProcess.clearFiles();
    },
    // 选中
    radioChangeEvent: function radioChangeEvent(_ref3) {
      var row = _ref3.row;
      this.selectRow = row;
    },
    cellClick: function cellClick(e) {
      // debugger
      this.selectRow = e.row; // console.log('e=================', e)
    },
    preview_data: function preview_data() {
      // const token = util.cookies.get('token')
      // const langArr = {
      //   'zh-chs': 'zh-CN,zh;',
      //   en: 'en-US,en;'
      // }
      // let lang = langArr[util.cookies.get('lang')]
      // config['Authorization'] = `Bearer ${token}`
      var token = util.cookies.get('token');
      var apiparam = 'ImsReel/GetBarCodeInfoByCode?code=M210927000024';
      var dataurl = this.$store.getters.getVUE_APP_IWMS_API + apiparam;
      var reportid = 'BarCodeTPL';
      var dxurl = this.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport'; // http://localhost:64522/
      // let url = `${dxurl}?DATA_URL=${dataurl}&REPORT_ID=${reportid}&Token=${token}`

      var url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(reportid, "&Token=").concat(token); // debugger
      // console.log('url',url);

      util.open(url);
    },
    down_tpl: function down_tpl() {
      if (this.selectRow == null) {
        this.$message.error(this.$t('请先选中一行。'));
        return false;
      }

      var rptfile = this.selectRow.PathName;

      if (!rptfile) {
        this.$message.warning('该记录没有模板文件');
        return;
      }

      var rpturl = this.$store.getters.getVUE_APP_PRINT_TPL + 'wwwroot' + rptfile;
      util.open(rpturl);
    }
  }
};